import {
  post,
  get
} from './http'
import global from '@/api/global'
var name = global.wmsAccessName
var driverNameData = global.driverName
var wmsCenter = global.wmsCenter
const smpName = global.smpName

// 变更作业导入货物
export const importChangeDetail = p => post(`/${name}/whOutstockSummary/importChangeDetail`, p)

// 进仓计划导入
export const importStorageJfStart = p => post(`/${name}/instock/importStorageJfStart`, p)

// 周口店进仓确认撤销
export const revokeStockConfirm = p => post(`/${name}/instockThreadExp/revokeStockConfirm`, p) // 更改货物信息

// 国铁库进仓计划
export const selectUpProduct = p => post(`/${name}/instock/selectUpProduct`, p) // 更改货物信息

// 国铁入库计划直接入库
export const inPlanInStockJf = p => post(`/${name}/instock/inPlanInStockJf`, p)
// 入库作业
export const batchCreateInstockProduct = p => post(`/${name}/instock/batchCreateInstockProduct`, p)
// 进仓计划
export const deleteStorageForJf = p => post(`/${name}/instock/deleteStorageForJf`, p)

// 建发进仓计划
export const exportJfInStockCargoList = p => post(`/${name}/instock/exportJfInStockCargoList`, p) // 进仓计划列表导出
export const getJfInStockCargoListAllWeight = p => post(`/${name}/instock/getJfInStockCargoListAllWeight`, p) // 进仓计划列表总重量
export const getJfInStockCargoList = p => post(`/${name}/instock/getJfInStockCargoList`, p) // 进仓计划列表
export const cDlist = p => post(`/${driverNameData}/cDriverInfo/list`, p) // 司机信息
// 建发出入库
export const JfaddOrUpdateThreadExp = p => post(`/${name}/instockThreadExp/addOrUpdateThreadExp`, p) // 入库计划新增修改
export const JfgetThreadExpList = p => post(`/${name}/instockThreadExp/getThreadExpList`, p) // 入库计划主表查询
export const JfgetThreadDetailExpList = p => post(`/${name}/instockThreadExp/getThreadDetailExpList`, p) // 入库计划子表查询
export const JfdeleteThreadExp = p => post(`/${name}/instockThreadExp/deleteThreadExp`, p) // 入库计划删除
export const JfgetThreadDetailExpWN = p => post(`/${name}/instockThreadExp/getThreadDetailExpWN`, p) // 入库计划总重量件数
export const JfunloadConfirm = p => post(`/${name}/instockThreadExp/unloadConfirm`, p) // 入库计划卸车确认
export const JfconfirmThreadExp = p => post(`/${name}/instockThreadExp/confirmThreadExp`, p) // 入库计划入库确认
export const JfgetThreadExpWeightp = p => post(`/${name}/instockThreadExp/getThreadExpWeight`, p) // 入库计划入库确认

// 建发进仓确认
export const JfgetStockConfirmList = p => post(`/${name}/instockThreadExp/getStockConfirmList`, p) // 待确认查询
export const JfexportStockConfirmList = p => post(`/${name}/instockThreadExp/exportStockConfirmList`, p) // 待确认导出
export const JfstockConfirm = p => post(`/${name}/instockThreadExp/stockConfirm`, p) // 待确认进仓确认
export const JfgetStockConfirmedList = p => post(`/${name}/instockThreadExp/getStockConfirmedList`, p) // 已确认查询
export const JfexportStockConfirmedList = p => post(`/${name}/instockThreadExp/exportStockConfirmedList`, p) // 已确认导出
export const JfstockConfirmUnpacking = p => post(`/${name}/instockThreadExp/stockConfirmUnpacking`, p) // 拆包
export const JfimportStockConfirmList = p => post(`/${name}/instockThreadExp/importStockConfirmList`, p) // 导入
export const JfexportStockConfirmExc = p => post(`/${name}/instockThreadExp/exportStockConfirmExc`, p) // 导入异常
export const JfmodifyStockConfirm = p => post(`/${name}/instockThreadExp/modifyStockConfirm`, p) // 修改
export const JfgetStorkConfirmedlList = p => post(`/${name}/instockThreadExp/getStorkConfirmedlList`, p) // 进仓单号修改记录
export const JfupdateCustomerJf = p => post(`/${name}/instock/updateCustomerJf`, p) // 进仓计划修改客户

// 字典
export const zidian = p => post(`/${name}/b/dictionary/getDictionary`, p)
export const zidianKuwei = p => post(`/${name}/instock/findWarehouses`, p)
export const zidianQuwei = p => post(`/${name}/instock/findLocation`, p)
export const zidianHuowei = p => post(`/${name}/instock/findBin`, p)
// 出入库接口
export const getRelationCustomer = p => post(`/${name}/instock/getRelationCustomer`, p)
export const printInstockDocumentScrewThreadSteel = p => post(`/${name}/instock/printInstockDocumentScrewThreadSteel`, p) // 虚捆包打印
export const rukuzuoyeList = p => post(`/${name}/instock/findInStockList`, p)
export const confirmStorageForJf = p => post(`/${name}/instock/confirmStorageForJf`, p) // 确认入库建发
export const confirmStorageJfEnd = p => post(`/${name}/instock/confirmStorageJfEnd`, p) // 进仓确认
export const JfstockConfirmPacking = p => post(`/${name}/instockThreadExp/stockConfirmPacking`, p) // 进仓确认合包
export const rykuAddList = p => post(`/${name}/instock/inStockAdd`, p)
export const xiugaiChaxun = p => post(`/${name}/instock/instockMasterFindById`, p)
export const xiugaiOk = p => post(`/${name}/instock/instockMasterUpdate`, p)
export const deleteRow = p => post(`/${name}/instock/instockMasterDelete`, p)
export const storageOk = p => post(`/${name}/instock/confirmStorage`, p)
export const addProduct = p => post(`/${name}/instock/createInstockProduct`, p)
export const findCargoList = p => post(`/${name}/instock/findNoInStockCargoList`, p)
export const uninStock = p => post(`/${name}/instock/uninStockDetermine`, p)
export const findInStock = p => post(`/${name}/instock/findInStockDetilList`, p)
export const singleProductF = p => post(`/${name}/instock/singleProductFindById`, p)
export const singleProductUpdate = p => post(`/${name}/instock/singleProductUpdate`, p)
export const inStockCheck = p => post(`/${name}/instock/inStockCheck`, p)
export const deleteInStockDetil = p => post(`/${name}/instock/deleteInStockDetil`, p)
export const ruKuDanGuanLi = p => post(`/${name}/instock/findInStockList`, p)
export const ruKuDanDetilList = p => post(`/${name}/instock/findInStockDetilList`, p)
export const printInstockSel = p => post(`/${name}/instock/printInstockSel`, p)
export const createInstockProductWith3pl = p => post(`/${name}/pl3Stock/isRelationWith3pl`, p) // 3pl相关
export const getAnalysisBy3pl = p => post(`/${name}/pl3Stock/getAnalysisBy3pl`, p) // 3pl相关
export const createInstockProductInStockPlanQuery = p => post(`/${name}/pl3Stock/createInstockProductInStockPlanQuery`, p)
export const getWhInplanMasterList = p => post(`/${name}/whInstockPlan/getWhInplanMasterList`, p)
export const addWhInplanMaster = p => post(`/${name}/whInstockPlan/addWhInplanMaster`, p)
export const deleteWhInplanMaster = p => post(`/${name}/whInstockPlan/deleteWhInplanMaster`, p)
export const getWhInplanDetailList = p => post(`/${name}/whInstockPlan/getWhInplanDetailList`, p)
export const deleteWhInplanDetailList = p => post(`/${name}/whInstockPlan/deleteWhInplanDetailList`, p) // 货物详情删除
export const importDet = p => post(`/${name}/whInstockPlan/import`, p)
export const importStock = p => post(`/${name}/instock/importStock`, p)
export const instockMasterUpdate = p => post(`/${name}/instock/instockMasteredUpdate`, p) /// wmsAccess/instock/instockMasterUpdate改为/wmsAccess/instock/instockMasteredUpdate
export const getWhInplanMasterListNoIntercept = p => post(`/${name}/whInstockPlan/getWhInplanMasterListNoIntercept`, p) // 平台入库
export const addWhInplanMasterNoIntercept = p => post(`/${name}/whInstockPlan/addWhInplanMasterNoIntercept`, p) // 添加
export const getTenantList = p => post(`/${name}/whInstockPlan/getTenantList`, p) // 租户
export const getCustomerListByTenant = p => post(`/${name}/whInstockPlan/getCustomerListByTenant`, p) // 客户
export const getTenantListBy = p => post(`/${name}/whInstockPlan/getTenantListBy`, p) // 客户
export const importStockXth = p => post(`/${name}/instock/importStockXth`, p) // 客户
export const inPlanInStockConfirm = p => post(`/${name}/instock/inPlanInStockConfirm`, p) // 同步

// 出库
export const chukuList = p => post(`/${name}/whOutstockPlan/getWhOutstockMasterList`, p) // 出库计划
export const getWhOutstockDetailListSummary = p => post(`/${name}/whOutstockPlan/getWhOutstockDetailListSummary`, p) // 出库计划-汇总
export const getWhOutstockMaster = p => post(`/${name}/whOutstockPlan/getWhOutstockMasterList`, p) // 出库作业
export const getFeeDetailList = p => post(`/${name}/whOutstockPlan/getFeeDetailList`, p) // 获取费用明细

export const getWhManage = p => post(`/${name}/whOutstockPlan/getWhManageOutstockMasterList`, p) // 出库单据
export const getLwgStockVehicleNumber = p => post(`/${name}/whOutstockPlan/getLwgStockVehicleNumber`, p) // 出库作业-车船号
export const getLwgStockCargoCount = p => post(`/${name}/whOutstockPlan/getLwgStockCargoCount`, p) // 出库作业-库存件数
export const addLwgWhOutstockDetail = p => post(`/${name}/whOutstockPlan/addLwgWhOutstockDetail`, p) // 出库作业-添加保存
// 快捷出库
export const importOutStockPlan = p => post(`/${name}/whOutstockPlan/importOutStockPlan`, p) // 导入

export const detailsList = p => post(`/${name}/whOutstockPlan/getWhOutstockDetailList`, p)
export const addWhOutstock = p => post(`/${name}/whOutstockPlan/addWhOutstockMaster`, p)
export const fingById = p => post(`/${name}/whOutstockPlan/getWhOutstockMaster`, p)
export const updateOk = p => post(`/${name}/whOutstockPlan/updateWhOutstockMaster`, p)
export const deleteWhOutstock = p => post(`/${name}/whOutstockPlan/deleteWhOutstockMaster`, p)
export const getWhOutstockPlan = p => post(`/${name}/whOutstockPlan/getWhOutstockPlanCargoList`, p)
export const okAddWhOutstock = p => post(`/${name}/whOutstockPlan/addWhOutstockDetail`, p)
export const addWhOutstockNM = p => post(`/${name}/whOutstockPlan/addWhOutstockrr`, p)
export const cancelWhOutstock = p => post(`/${name}/whOutstockPlan/deleteWhOutstockDetail`, p)
export const getDetailList = p => post(`/${name}/whOutstockPlan/getWhOutstockDetailList`, p)
export const checkWhOutstock = p => post(`/${name}/whOutstockPlan/checkWhOutstockDetail`, p)
export const confirmWhOutstock = p => post(`/${name}/whOutstockPlan/confirmWhOutstock`, p)
export const getWhManageOutstock = p => post(`/${name}/whOutstockPlan/getWhManageOutstockDetailList`, p)
export const revokeWhOutstock = p => post(`/${name}/whOutstockPlan/revokeWhOutstock`, p)
export const stockMaster = p => post(`/${name}/whOutstockPlan/getWhOutstockMaster`, p)
export const updateWhOutstockMaster = p => post(`/${name}/whOutstockPlan/updateWhOutstockMaster`, p)
export const printOutstockDocument = p => post(`/${name}/whOutstockPlan/printOutstockDocument`, p)
export const exportOutStockWord = p => post(`/${name}/whOutstockPlan/exportOutStockWord`, p) // pdf
export const unlockWhOutstockMaster = p => post(`/${name}/whOutstockPlan/unlockWhOutstockMaster`, p)
export const deleteWhOutstockDetailForSD = p => post(`/${name}/whOutstockPlan/deleteWhOutstockDetailForSD`, p)
export const deleteWhOutstockDetailForPc = p => post(`/${name}/whOutstockPlan/deleteWhOutstockDetailForPc`, p)// 取消关联20250617
export const synStocks = p => post(`/${name}/instock/synStocks`, p)
export const queryAllRoles = p => post(`${smpName}/api/queryAllRoles`, p)
export const updateReverseFee = p => post(`/${name}/whOutstockPlan/updateReverseFee`, p)

// 二维码
export const getDecodeRuleMstList = p => post(`/${name}/qrCodeAnalysis/getDecodeRuleMstList`, p)
export const getDecodeRuleDtlList = p => post(`/${name}/qrCodeAnalysis/getDecodeRuleDtlList`, p)
export const getProductSpuDtlList = p => post(`/${name}/qrCodeAnalysis/getProductSpuDtlList`, p)
export const addDecodeRule = p => post(`/${name}/qrCodeAnalysis/addDecodeRule`, p)
export const deleteDecodeRule = p => post(`/${name}/qrCodeAnalysis/deleteDecodeRule`, p)
export const checkRule = p => post(`/${name}/qrCodeAnalysis/checkRule`, p)
export const startUsingDecodeRule = p => post(`/${name}/qrCodeAnalysis/startUsingDecodeRule`, p)
export const getDecodeRuleMst = p => post(`/${name}/qrCodeAnalysis/getDecodeRuleMst`, p)
export const updateDecodeRuleMst = p => post(`/${name}/qrCodeAnalysis/updateDecodeRuleMst`, p)
export const getDecodeRuleDtl = p => post(`/${name}/qrCodeAnalysis/getDecodeRuleDtl`, p)
export const updateDecodeRuleDtl = p => post(`/${name}/qrCodeAnalysis/updateDecodeRuleDtl`, p)
// 反馈
export const selectInstockFeedbackList = p => post(`/${name}/pl3Stock/selectInstockFeedbackList`, p)
export const instockFeedbackDelete = p => post(`/${name}/pl3Stock/instockFeedbackDelete`, p)
export const instockFeedback = p => post(`/${name}/pl3Stock/instockFeedback`, p)
export const chuKuList2 = p => post(`/${name}/pl3Stock/selectOutstockFeedbackList`, p)
export const selectOutstockFeedbackPlanQuery = p => post(`/${name}/pl3Stock/selectOutstockFeedbackPlanQuery`, p)
export const getOutstockFeedbackWeight = p => post(`/${name}/pl3Stock/getOutstockFeedbackWeight`, p)
export const outstockFeedback = p => post(`/${name}/pl3Stock/outstockFeedback`, p)
export const outstockFeedbackVirtual = p => post(`/${name}/pl3Stock/outstockFeedbackVirtual`, p)
export const outstockFeedbackDelete = p => post(`/${name}/pl3Stock/outstockFeedbackDelete`, p)
export const getCargoDamagePicture = p => post(`/${name}/instock/getCargoDamagePicture`, p)
export const selectInstockFeedbackPlanQuery = p => post(`/${name}/pl3Stock/selectInstockFeedbackPlanQuery`, p)
// 添加螺纹钢
export const printOutstockDocumentScrewThreadSteel = p => post(`/${name}/whOutstockPlan/printOutstockDocumentScrewThreadSteel`, p) // -出库计划
export const selectScrewThreadSteelAttribute = p => post(`/${name}/inStockInstruction/selectScrewThreadSteelAttribute`, p)
export const addWhInplanForScrewThreadSteel = p => post(`/${name}/inStockInstruction/addWhInplanForScrewThreadSteel`, p)
export const deleteWhInplanForScrewThreadSteel = p => post(`/${name}/inStockInstruction/deleteWhInplanForScrewThreadSteel`, p)
// 磅重记录
export const findWeightList = p => post(`/${name}/weighing/findWeightList`, p) // 磅重查询
export const deleteWeight = p => post(`/${name}/weighing/deleteWeight`, p) // 磅重删除
export const updateWeight = p => post(`/${name}/weighing/updateWeight`, p) // 磅重修改
export const updateWeightForVip = p => post(`/${name}/weighing/updateWeightForVip`, p) // 磅重修改
export const tareWeightAdd = p => post(`/${name}/weighing/tareWeightAdd`, p) // 磅重皮重
export const grossWeightAdd = p => post(`/${name}/weighing/grossWeightAdd`, p) // 毛重
export const cancelWeighting = p => post(`/${name}/weighing/cancelWeighting`, p) // 撤销
// 修改时间instock/updateInStockDate
export const updateInStockDate = p => post(`/${name}/instock/updateInStockDate`, p) // 入库
export const updateOutStockDate = p => post(`/${name}/whOutstockPlan/updateOutStockDate`, p) // 出库
// 入库明细instock/selectGroupByVehicleNumber
export const selectGroupByVehicleNumber = p => post(`/${name}/instock/selectGroupByVehicleNumber`, p) // 1.车船号
export const selectScrewThreadSteelAttributeDropDown = p => post(`/${name}/inStockInstruction/selectScrewThreadSteelAttributeDropDown`, p) // 1.品牌数据---
export const confirmStorageForWeighing = p => post(`/${name}/weighing/confirmStorageForWeighing`, p) // 1.磅单-确认入库
export const getWhInstockDetailListSummary = p => post(`/${name}/whInstockPlan/getWhInstockDetailListSummary`, p) // 入库-汇总
// 变更记录

export const fidListSummaryRecord = p => post(`/${name}/whOutstockPlan/fidListSummaryRecord`, p) // 出库变更
export const deleteTOutstockSummary = p => post(`/${name}/whOutstockPlan/deleteTOutstockSummary`, p) // 出库计划-删除
export const checkTOutstockSummary = p => post(`/${name}/whOutstockPlan/checkTOutstockSummary`, p) // 出库计划-删除
// 磅单记录修改时间
export const updateWeightDate = p => post(`/${name}/weighing/updateWeightDate`, p)
// 京铁云导入
export const importStockXuanGang = p => post(`/${name}/instock/importStockXuanGang`, p)
// 入库单据-中厚板导入
export const importStockPlate = p => post(`/${name}/instock/importStockPlate`, p)
// 仓库入库指令-生成入库单
export const inStockNoLoadingplanId = p => post(`/${name}/inStockInstruction/inStockNoLoading`, p)

export const getWarehouseList = p => post(`/${name}/cargoCoordinatePosition/getWarehouseList `, p) // 智能仓
export const getCargoCoordinateList = p => post(`/${name}/cargoCoordinatePosition/getCargoCoordinateList`, p) // 智能仓-货位信息
export const getInOutStockList = p => post(`/${name}/cargoCoordinatePosition/getInOutStockList`, p) // 智能列表信息

// 智能列表1-出库主信息
export const fidListOutstockMasterForAi = p => post(`/${name}/whOutstockPlan/fidListOutstockMasterForAi`, p)
// 智能列表1-出库主信息-详情数据
export const fidListOutstockDetail = p => post(`/${name}/whOutstockPlan/fidListOutstockDetail`, p)
// 智能列表1-智能仓库货物查询
export const getCargoCoordinateListForWhId = p => post(`/${wmsCenter}/warehouseForAi/getCargoCoordinateListForWhId`, p)
export const getYCargoListForLeftToRight = p => post(`/${wmsCenter}/warehouseForAi/getYCargoListForLeftToRight`, p)
// 天车接口
export const positionTianChe = p => post(`/${wmsCenter}/warehouseForAi/getCoordinate`, p)

// 手动添加提单：
export const getWhOutstockPlanCargoList = p => post(`/${name}/whOutstockPlan/getWhOutstockPlanCargoList`, p) // 添加货物 弹窗接口
// 建发-入库-进仓确认-待确认-总吨数、总件数
export const jfGetStockConfirmNumber = p => post(`/${name}/instockThreadExp/getStockConfirmNumber`, p)

// 火运预报
export const railwayForecastList = p => post(`/${name}/railwayForecast/list`, p)
export const railwayForecastAdd = p => post(`/${name}/railwayForecast/addOrUpdate`, p)
export const WeightAndPiece = p => post(`/${name}/railwayForecast/weightAndPiece`, p)
export const getTRailwayForecast = p => post(`/${name}/railwayForecast/getTRailwayForecast/${p}`)
export const remove = p => post(`/${name}/railwayForecast/remove/${p}`)
export const importExcel = p => post(`/${name}/railwayForecast/importExcel`, p)
export const billList = p => post(`/${name}/dispatcher/inStock/billList/${p}`)
// ----------------------广州天又天---------------------
// 船运预报-新增
export const addMasterAndSummary = p => post(`/${name}/shipForecast/addMasterAndSummary`, p)
// 船运预报-修改数据回显
export const getMasterDetailById = p => post(`/${name}/shipForecast/getMasterDetailById/${p}`)
// 船运预报-修改
export const updateMaster = p => post(`/${name}/shipForecast/updateMaster`, p)
// 船运预报-查询
export const getMasterList = p => post(`/${name}/shipForecast/getMasterList`, p)
// 船运预报-总吨数与总件数
export const getWeightAndPiece = p => post(`/${name}/shipForecast/getWeightAndPiece`, p)
// 船运预报-删除
export const removeMaster = p => post(`/${name}/shipForecast/removeMaster/${p}`)
// 船运预报-货物明细列表
export const getSummaryList = p => post(`/${name}/shipForecast/getSummaryList`, p)
// 船运预报-货物明细查询条件
export const getSummaryDropDown = p => post(`/${name}/shipForecast/getSummaryDropDown/${p}`)
// 船运预报-货物明细总吨数，总件数
export const getSummaryPlanWeightAndPiece = p => post(`/${name}/shipForecast/getSummaryPlanWeightAndPiece`, p)
// 船运预报-货物明细-新增
export const addSummary = (params, p) => post(`/${name}/shipForecast/addSummary/${p}`, params)
// 船运预报-货物明细-删除
export const removeSummary = p => post(`/${name}/shipForecast/removeSummary/${p}`)
// 船运预报-添加入库计划-车牌号搜索
export const getVehicleNoList = p => post(`/${name}/shipForecast/getVehicleNoList`, p)
// 船运预报-添加入库计划-获取货物信息
export const getSummaryListNoPage = p => post(`/${name}/shipForecast/getSummaryListNoPage`, p)
// 船运预报-添加入库计划-保存
export const createInstockMasterAndSummary = p => post(`/${name}/shipForecast/createInstockMasterAndSummary`, p)
// 入库同步皮重
export const getLatestInTareWeightInfo = p => post(`/${name}/shipStock/getLatestInTareWeightInfo`, p)
// 出库同步皮重
export const getLatestOutGrossWeightInfo = p => post(`/${name}/shipStock/getLatestOutGrossWeightInfo`, p)
// ---------------------入库计划-----------------
// 入库计划-新增
export const createInstockPlan = p => post(`/${name}/shipStock/createInstockPlan`, p)
// 入库计划-修改
export const updateInstockPlan = p => post(`/${name}/shipStock/updateInstockPlan`, p)
// 入库计划-确认入库
export const confirmInstock = (params, p) => post(`/${name}/shipStock/confirmInstock/${p}`, params)
// 入库计划-删除
export const removeInstockPlan = p => post(`/${name}/shipStock/removeInstockPlan/${p}`)
// 入库计划-过磅弹框货物信息列表
export const getInWeightInfoList = p => post(`/${name}/shipStock/getInWeightInfoList/${p}`)
// 入库计划-过磅刷新操作
export const calculateWeight = p => post(`/${name}/shipStock/calculateWeight`, p)
// 入库计划-合磅刷新操作
export const mergeWeight = p => post(`/${name}/shipStock/mergeWeight`, p)
// 入库计划-查询单个货物详情的过磅记录
export const getInWeightInfo = p => post(`/${name}/shipStock/getInWeightInfo/${p}`)
// 入库计划-过磅保存
export const shipStockWeight = p => post(`/${name}/shipStock/weight`, p)
// 进仓确认-进仓确认操作
export const confirmToStrage = p => post(`/${name}/shipStock/confirmToStrage`, p)
// 入库过磅记录列表查询
export const getInStockWeightInfoList = p => post(`/${name}/shipStock/getInStockWeightInfoList`, p)
// 修改过磅记录的毛重
export const updateGrossWeight = p => post(`/${name}/shipStock/updateWeightInfo/grossWeight`, p)
// 修改过磅记录的毛重时间
export const updateGrossWeightTime = p => post(`/${name}/shipStock/updateWeightInfo/grossWeightTime`, p)
// 清空毛重
export const clearGrossWeight = p => post(`/${name}/shipStock/clearGrossWeight/${p}`)
// 清空皮重
export const clearTareWeight = p => post(`/${name}/shipStock/clearTareWeight/${p}`)
// 库存-客户库存-列表查询
export const stockCustomerGetList = p => post(`/${name}/shipStock/stockCustomer/getList`, p)
// 库存-客户库存-总吨数与总件数
export const getAllWeightAndPiece = p => post(`/${name}/shipStock/stockSummary/getAllWeightAndPiece`, p)
// 库存-在库库存-列表查询
export const stockSummaryList = p => post(`/${name}/shipStock/stockSummary/list`, p)
// 库存-在库库存-总吨数、总件数
export const allPieceAndWeight = p => post(`/${name}/shipStock/stockSummary/allPieceAndWeight`, p)
// 入库记录-查询
export const instockRecordExcelList = p => post(`/${name}/shipStock/instockRecordExcel/list`, p)
// 入库记录-删除
export const instockRecordRemove = p => post(`/${name}/shipStock/instockRecord/remove/${p}`)
// 删除记录-查询
export const revokeRecordList = p => post(`/${name}/shipStock/revokeRecord/list`, p)
// 进仓记录-已确认-查询
export const getConfirmedList = p => post(`/${name}/shipStock/getConfirmedList`, p)
// 在库库存-盘盈盘亏
export const clearStock = p => post(`/${name}/shipStock/stockSummary/clearStock/${p}`)
// 入库计划-子表查询
export const getInstockSummaryList = p => post(`/${name}/shipStock/getInstockSummaryList`, p)
// 出库计划-过磅刷新操作
export const calculateOutStockWeight = p => post(`/${name}/shipStock/calculateOutStockWeight`, p)
// 出库计划-合磅刷新操作
export const mergeOutStockWeight = p => post(`/${name}/shipStock/mergeOutStockWeight`, p)
// 历史库存-查询
export const stockSummaryHistoryList = p => post(`/${name}/shipStock/stockSummaryHistory/List`, p)
// 历史库存-历史库存总吨数与总件数
export const weightAndPiece = p => post(`/${name}/shipStock/stockSummaryHistory/weightAndPiece`, p)
// 出库过磅记录-查询
export const getOutStockWeightInfoList = p => post(`/${name}/shipStock/getOutStockWeightInfoList`, p)
// 修改过磅记录的皮重
export const updatetareWeight = p => post(`/${name}/shipStock/updateWeightInfo/tareWeight`, p)
// 修改过磅记录的皮重时间
export const updatetareWeightTime = p => post(`/${name}/shipStock/updateWeightInfo/tareWeightTime`, p)
// 在库库存导入
export const stockSummaryImport = p => post(`/${name}/shipStock/stockSummary/import`, p)
// 获取在库库存可操作件数
export const getAvailableTransferCount = p => post(`/${name}/shipStock/stockSummary/getAvailableTransferCount/${p}`)
// 在库库存移库操作
export const transferWarehouse = p => post(`/${name}/shipStock/transferWarehouse`, p)
// 在库库存客户可移件数
export const getCustomerAvailableNumberAccess = p => post(`/${name}/shipStock/getCustomerAvailableNumber`, p)
// 亏涨记录-查询
export const getStockClearRecordList = p => post(`/${name}/shipStock/getStockClearRecordList`, p)
// 亏涨记录-吨数
export const getStockClearRecordWeight = p => post(`/${name}/shipStock/getStockClearRecordWeight`, p)
// 在库库存-转货保存
export const changeGoodsOwnerS = p => post(`/${name}/shipStock/changeGoodsOwner`, p)
// 出库获取磅单记录
export const getOutWeightInfo = p => post(`/${name}/shipStock/getOutWeightInfo/${p}`)
// 入库单据-导入
export const importInstockBill = p => post(`/${name}/shipStock/importInstockBill`, p)
// 连接过磅实时数据
export const getPoundWeight = p => post(`/${name}/shipStock/getPoundWeight`, p)
// 入库作业，推送到现场
export const inStockPush = p => post(`/${name}/instock/inStockPush`, p)
// 入库作业，推送到现场
export const inStockAddForZhb = p => post(`/${name}/instock/inStockAddForZhb`, p)
// 天又天出库计划合磅清空毛重
export const clearOutStockWeightInfo = p => post(`/${name}/shipStock/clearOutStockWeightInfo`, p)
// 天又天出库计划过磅清空毛重
export const clearSpecifiedWeightInfo = p => post(`/${name}/shipStock/clearSpecifiedWeightInfo`, p)
// 广州粤运仓，入库->入库计划，点击确认入库的时候，入库货物件数大于船运预报件数，给出提示
export const checkShipForecastActualNumber = p => post(`/${name}/shipStock/checkShipForecastActualNumber`, p)
// 广州粤仓运到货预报手动到货完成
export const updateMasterForArrivalComplete = p => post(`/${name}/shipForecast/updateMasterForArrivalComplete`, p)

// 建材入库结算
export const getfeeJc = p => post(`/${name}/instockThreadExp/getfeeJc`, p)

// 入库进仓确认结算客户修改
export const getFeeCustomerDisplay = p => post(`/${name}/instockThreadExp/getFeeCustomerDisplay`, p)

// 到货方式接口
export const arrivalMethod = p => post(`/${name}/b/dictionary/getDictionary/arrival_method`, p)
export const getStockNumber = p => post(`${name}/whOutstockPlan/getStockNumber`, p)
// 入库作业
export const updateUnloadingSite = p => post(`${name}/instock/updateUnloadingSite`, p)
// 出库单-判断智能仓存在未出库货物
export const checkBcOutStock = p => post(`${name}/whOutstockPlan/checkBcOutStock`, p)
export const printOutstockDocuments = p => post(`${name}/tmsZw/printOutstockDocuments`, p)// 兴瀚出库单打印--多选
export const getRemainingCount = p => post(`${name}/t/goods/code/getRemainingCount`, p)// 入库作业-按照编码顺序自动生成货物编码
export const updateReverseWeight = p => post(`${name}/whOutstockPlan/updateReverseWeight`, p)// 编辑倒垛重量接口
export const getInStockTicket = p => post(`${name}/instock/getInStockTicket`, p)// 编辑倒垛重量接口
export const printOutstockDocumentLwg = p => post(`/${name}/whOutstockSummary/printOutstockDocument`, p) // 出库 打印装车单||打印出库单
export const deleteInstockCheck = p => post(`/${name}/instock/deleteInstockCheck`, p)// 兴瀚中厚板入库校验-货物删除
export const confirmInstockCheck = p => post(`/${name}/instock/confirmInstockCheck`, p)// 兴瀚中厚板入库查验保存OR查验完成
export const getOutStockZhbImage = p => post(`/${name}/whOutstockPlan/getOutStockZhbImage`, p)// 查看出库单中厚板图片
export const uploadOutStockZhbImage = p => post(`/${name}/whOutstockPlan/uploadOutStockZhbImage`, p)// 上传出库单中厚板图片
export const deleteOutStockZhbImage = p => post(`/${name}/whOutstockPlan/deleteOutStockZhbImage`, p)// 删除出库单中厚板图片
export const inPlanInStockXh = p => post(`/${name}/instock/inPlanInStockXh`, p)// 兴瀚入库计划货物详情入库功能
export const getAutoCargoCode = p => post(`/${name}/cargoBarcodeAuto/getAutoCargoCode`, p)// 入库作业获取捆包号
// 出库单据 修改计算方式 20230227
export const updateSettlementMethod = p => post(`/${name}/whOutstockPlan/updateSettlementMethod`, p)
// 入库作业上传大票 20240411
export const saveInStockTicket = p => post(`/${name}/instock/saveInStockTicket`, p)

// 修改运输计划号 20240528
export const updateTransportPlanNo = p => post(`/${name}/instock/updateTransportPlanNo`, p)

// 校验是否入库
export const confirmStorageCheck = p => post(`/${name}/instock/confirmStorageCheck`, p)
//  中厚板智能加货
export const confirmIntelligentStorageZhb = p => post(`/${name}/instock/confirmIntelligentStorageZhb`, p)
//  入库单-标签打印-获取货物信息
export const findGoodsByCargoId = p => post(`/${name}/instock/findGoodsByCargoId`, p)
//  出库计划-新建出库单-兴瀚库
export const addWhOutstockMasterCertificate = p => post(`/${name}/whOutstockPlan/addWhOutstockMasterCertificate`, p)
//  出库计划-修改出库单-兴瀚库
export const updateWhOutstockMasterCertificate = p => post(`/${name}/whOutstockPlan/updateWhOutstockMasterCertificate`, p)

//  查询仓库产地列表
export const findSteelMillNameList = p => post(`/${name}/instock/findSteelMillNameList`, p)
//  入库作业-智能添加
export const confirmIntelligentAddition = p => post(`/${name}/instock/confirmIntelligentAddition`, p)
//  入库作业-查看货损图片
export const getCargoDamagePictureListXh = p => post(`/${name}/instock/getCargoDamagePictureListXh`, p)
//  入库作业-货损上传
export const cargoDamageUpload = p => post(`/${name}/instock/cargoDamageUpload`, p)
//  入库作业-品名列表
export const findProductNameList = p => post(`/${name}/instock/findProductNameList`, p)
//  超吨审核
export const getOverweightAuditList = p => post(`/${name}/whOutstockPlan/getOverweightAuditList`, p)// 列表
export const updateOverweightAudit = p => post(`/${name}/whOutstockPlan/updateOverweightAudit`, p)// 审核
export const repealOverweightAudit = p => post(`/${name}/whOutstockPlan/repealOverweightAudit`, p)// 撤销
// 库存管理-查看费用
export const getStockFeeDetailList = p => post(`/${name}/whOutstockPlan/getStockFeeDetailList`, p)
// 建发入库单据-上传凭证
export const saveInStockReceipt = p => post(`/${name}/instockThreadExp/saveInStockReceipt`, p)

//  兴瀚预约进厂 1、出库计划 添加，车辆进厂 2、提单作业
export const visitauditAdd = p => post(driverNameData + '/visitaudit/add', p)
//= =cosco搬过来的接口==============
// 螺纹钢入库
export const getThreadMasterList = p => post(`/${name}/instockThread/getThreadMasterList`, p) // 主表查询
export const addOrUpdateThreadMaster = p => post(`/${name}/instockThread/addOrUpdateThreadMaster`, p)
export const addOrUpdateThreadProduct = p => post(`/${name}/instockThread/addOrUpdateThreadProduct`, p)
export const deleteThreadMaster = p => post(`/${name}/instockThread/deleteThreadMaster`, p) // 主表删除
export const confirmThreadStorage = p => post(`/${name}/instockThread/confirmThreadStorage`, p) // 确认入库
export const getThreadSummaryList = p => post(`/${name}/instockThread/getThreadSummaryList`, p) // 货物详情
export const deleteThreadProduct = p => post(`/${name}/instockThread/deleteThreadProduct`, p) // 货物详情删除
export const getThreadSummaryTotalWN = p => post(`/${name}/instockThread/getThreadSummaryTotalWN`, p) // 货物详情总重量
export const getThreadMasterWeightCharge = p => post(`/${name}/instockThread/getThreadMasterWeightCharge`, p) // 货物详情总重量
// 入库计划 确认入库中远2.0
export const confirmThreadCw = p => post(`/${name}/instockThread/confirmThreadCw`, p)
export const findCustomerList = p => post(`/${wmsCenter}/cmc/findCustomerList`, p)// 入库外部单号是否必填
// 进仓确认待进仓列表
export const waitEnteredZy = p => post(`/${name}/instockThread/waitEnteredZy`, p)
// 进仓确认待进仓总件数、总吨数
export const getWaitEnteredZyWeightNumber = p => post(`/${name}/instockThread/getWaitEnteredZyWeightNumber`, p)
// 进仓确认已进仓列表
export const alreadyEnteredZy = p => post(`/${name}/instockThread/alreadyEnteredZy`, p)
// 进仓确认已进仓总件数、总吨数
export const getAlreadyEnteredZyWeightNumber = p => post(`/${name}/instockThread/getAlreadyEnteredZyWeightNumber`, p)
// 进仓确认操作
export const stockConfirmZy = p => post(`/${name}/instockThread/stockConfirmZy`, p)
// 进仓确认-撤销
export const revokeStockConfirmZy = p => post(`/${name}/instockThread/revokeStockConfirmZy`, p)
export const modifyStockConfirmZy = p => post(`/${name}/instockThread/modifyStockConfirmZy`, p)
// 进仓单修改记录查询
export const getStorkConfirmedlList = p => post(`/${name}/instockThreadExp/getStorkConfirmedlList`, p)
// 出库计划  关联货物
export const addTOutstockSummaryZyControl = p => post(`/${name}/whOutstockSummary/addTOutstockSummaryZyControl`, p)
// 螺纹钢出库计划
export const getOutstockMasterList = p => post(`/${name}/whOutstockSummary/getOutstockMasterList`, p) // 出库 列表
export const getOutstockSummaryList = p => post(`/${name}/whOutstockSummary/getOutstockSummaryList`, p) // 出库 货物明细 列表
export const addWhOutstockMaster = p => post(`/${name}/whOutstockSummary/addWhOutstockMaster`, p) // 出库 新增出库单
export const updateWhOutstockMasterLwg = p => post(`/${name}/whOutstockSummary/updateWhOutstockMaster`, p) // 出库  修改 放车

export const getWhOutstockMasterLwg = p => post(`/${name}/whOutstockSummary/getWhOutstockMaster`, p) // 出库 取得出库单（修改出库单用）
export const deleteWhOutstockMaster = p => post(`/${name}/whOutstockSummary/deleteWhOutstockMaster`, p) // 出库 删除出库单
export const getLwgTStockSummaryGroup = p => post(`/${name}/whOutstockSummary/getLwgTStockSummaryGroup`, p) // 出库 关联货物（螺纹钢）相关下拉框
export const getPlgxTStockSummaryGroup = p => post(`/${name}/whOutstockSummary/getPlgxTStockSummaryGroup`, p) // 出库 关联货物（盘螺、高线）相关下拉框
export const addTOutstockSummary = p => post(`/${name}/whOutstockSummary/addTOutstockSummary`, p) // 出库 出库单添加货物确定
export const delTOutstockSummary = p => post(`/${name}/whOutstockSummary/delTOutstockSummary`, p) // 出库 出库单删除货物明细
export const getTOutstockSummary = p => post(`/${name}/whOutstockSummary/getTOutstockSummary`, p) // 出库 取得出库汇总表（装车确认用）
export const updateTOutstockSummary = p => post(`/${name}/whOutstockSummary/updateTOutstockSummary`, p) // 出库 装车确认
export const confirmWhOutstockLwg = p => post(`/${name}/whOutstockSummary/confirmWhOutstock`, p) // 出库 确认出库
export const printOutstockDocumentList = p => post(`/${name}/whOutstockSummary/printOutstockDocumentList`, p) // 出库 打印装车单||打印出库单
export const updateTOutstockSummaryZy = p => post(`/${name}/whOutstockSummary/updateTOutstockSummaryZy`, p)
// 出库计划  装车确认
export const updateTOutstockSummaryZyControl = p => post(`/${name}/whOutstockSummary/updateTOutstockSummaryZyControl`, p)
// 五矿对接
export const findFileList = p => post(`/${wmsCenter}/cmc/findFileList`, p)// 附件列表
export const findVehicalList = p => post(`/${wmsCenter}/cmc/findVehicalList`, p)// 人车列表
export const findChangeMainList = p => post(`/${wmsCenter}/cmc/findChangeMainList`, p)// 转货通知列表
export const findChangeGoodsList = p => post(`/${wmsCenter}/cmc/findChangeGoodsList`, p)// 转货货物列表
// 出库计划关联货物保存
export const addTOutstockSummaryZy = p => post(`/${name}/whOutstockSummary/addTOutstockSummaryZy`, p)
export const confirmWhOutstockZy = p => post(`/${name}/whOutstockSummary/confirmWhOutstockZy`, p)
//= =cosco搬过来的接口结束==============
// 吨包货损上传
export const uploadInStockDbDamageGoods = p => post(`/${name}/instockThread/uploadInStockDbDamageGoods`, p)// 上传
export const findInStockDbDamageGoods = p => post(`/${name}/instockThread/findInStockDbDamageGoods`, p)// 查看
